import moment from 'moment';
import { filterNames } from './filterNames';

export const loadingStates = {
  loaded: 'loaded',
  longLoading: 'longLoading',
  noResult: 'noResult',
};

export const sortParams = {
  EXPIRED: 'Expired',
  CLOSED: 'CloseDate',
  URGENCY: 'Urgency',
  EXECUTE_TIME: 'ExecuteTime',
  ID: 'Id',
  STATUS: 'Status',
  MASTER: 'Master',
  SERVICE: 'Service',
  ADDRESS: 'Address',
  CLOSED_NOT_DONE: 'CloseNotDoneDate',
  SORT_STAGE_LIFE_CYCLE: 'StageLifeCycle',
};

export const filterType = 'STATISTICS';

export const searchDateFormat = 'YYYY-MM-DD';

export const createDateDefaultValue = [
  moment().subtract(7, 'days').startOf('day').format(searchDateFormat),
  moment().endOf('day').format(searchDateFormat),
];


export const statusesDefaultValue = [1, 2];

export const activeRequestsStatuses = [1, 2];

export const initRequestsCounts = {
  all: undefined,
  active: undefined,
  immediate: undefined,
  expired: undefined,
  retry: undefined,
  chargeable: undefined,
  averageLifetime: undefined,
};

export const initChartsRequests = {
  [filterNames.masters]: [],
  [filterNames.executers]: [],
  [filterNames.parentServices]: [],
  [filterNames.services]: [],
  [filterNames.houses]: [],
  [filterNames.marks]: [],
  [filterNames.regions]: [],
  [filterNames.ratings]: [],
  requestsByDate: [],
};

export const mastersType = {
  all: 'allMasters',
  active: 'activeMasters',
};

export const requestActionNames = {
  excel: 'excel',
  print: 'print',
};

export const horizontalChartPlaceholderType = {
  EXECUTER: 'ФИО',
  ADDRESS: 'адрес',
  SERVICE: 'причина',
  PARENT_SERVICE: 'услуга',
};
